import { Select, Tooltip } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { getVeraeusserungsformLabel } from "../../../../components/PeriodBasedComponents/MarketingTypeTable/MarketingTypeTable.constants";
import { HeaderWithHelpIcon } from "../../../../mantine/mrt/components/header/HeaderWithHelpIcon";
import { Veraeusserungsform } from "../../../../types/api.types";
import type {
  ExpressOnboardingEegColumnProps,
  ExpressOnboardingGenerator
} from "../../ExpressOnboarding.types";
import { useExpressOnboardingEegSave } from "../hooks/useExpressOnboardingEegSave";

const VERAEUSSERUNGSFORM_OPTIONS = Object.values(Veraeusserungsform).map(
  (vaForm) => ({
    label: getVeraeusserungsformLabel(vaForm),
    value: vaForm
  })
);

function getExpressOnboardingTableVerausserungsformColumn({
  getError,
  setError,
  getDraft,
  updateDraft,
  clearDraft,
  clearError
}: ExpressOnboardingEegColumnProps): MRT_ColumnDef<ExpressOnboardingGenerator> {
  return {
    id: "veraeusserungsform",
    accessorKey: "veraeusserungsform",
    header: "Veräußerungsform",
    Header: () => (
      <HeaderWithHelpIcon
        headerText="Veräußerungsform"
        helpText="Wenn Sie mehrere zeitveränderliche Werte eintragen wollen,
        nutzen Sie bitte die Eingabemaske in der Liegenschaft unter „Erzeuger”."
      />
    ),
    enableGlobalFilter: false,
    Cell: ({ cell, row }) => {
      const value =
        cell.getValue<ExpressOnboardingGenerator["veraeusserungsform"]>();

      const rowDraft = getDraft(row.original.id);
      const currentValue =
        rowDraft && "veraeusserungsform" in rowDraft
          ? (rowDraft.veraeusserungsform ?? null)
          : value;
      const { save, rowIsSaving } = useExpressOnboardingEegSave(row.original, {
        getError,
        setError,
        getDraft,
        updateDraft,
        clearDraft,
        clearError
      });

      const cantEditReason = row.original.uneditable_fields?.veraeusserungsform;

      return (
        <Tooltip disabled={!cantEditReason} label={cantEditReason}>
          <Select
            data={VERAEUSSERUNGSFORM_OPTIONS}
            disabled={!!cantEditReason || rowIsSaving}
            error={getError(row.original.id, "veraeusserungsform")}
            loading={rowIsSaving}
            value={currentValue}
            onChange={(newValue) => {
              const hasChange = newValue !== currentValue;
              if (!hasChange) {
                return;
              }

              const patch = {
                veraeusserungsform: newValue as Veraeusserungsform | null
              };
              updateDraft(row.original.id, patch);
              save(patch);
            }}
          />
        </Tooltip>
      );
    }
  };
}

export { getExpressOnboardingTableVerausserungsformColumn };
